import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowRightStartOnRectangleIcon, PencilSquareIcon } from '@heroicons/react/24/outline';

import { COMMUNITY_ROUTES } from '~/constants/community';

import { ActionMenu, type ActionMenuItem } from '../../ui/ActionMenu';

import type { Space } from '../../../_hooks/useSpace';
import { useSpaceAccess } from '../../../_hooks/useSpaceAccess';

export const CityChannelMenu: FC<{ space: Space }> = ({ space }) => {
  const { t } = useTranslation();
  const { isSpacePlaced } = useSpaceAccess();

  const isPlaced = isSpacePlaced(space);
  if (!isPlaced && !space.joined) return null;

  const item: ActionMenuItem = isPlaced
    ? {
        key: 'update-location',
        label: t('community.cities.update_location'),
        icon: PencilSquareIcon,
        to: `${COMMUNITY_ROUTES.memberEdit}#community-edit-location`,
      }
    : {
        key: 'leave',
        label: t('community.space.leave'),
        icon: ArrowRightStartOnRectangleIcon,
        variant: 'danger',
        onClick: space.onToggle,
      };

  return <ActionMenu items={[item]} triggerLabel={t('community.cities.options')} />;
};
